<template>
    <div>
         <Breadcrumb :headers="headers"></Breadcrumb>
        <List
            url="getFileExhibitions" :tanle="tanle" :update="updateList" 
            :operat="operat"  :isAdd="false" :afterList="dealListData" 
            :data="searchData" @download="download" @download2="download2">

           <div slot="Filter">
                <label style="margin-left:10px;">Topic：</label>
                <el-select style="width:200px;" v-model="searchData.Topic" placeholder="">
                    <el-option
                        v-for="item in topicList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <label style="margin-left:10px;">Document Type：</label>
                <el-select style="width:200px;" v-model="searchData.DocumentType" placeholder="">
                    <el-option
                        v-for="item in documentTypeList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
            </div>
            <div slot="Tail" style="margin-top:40px; margin-bottom:10px;">
                <label >Note: For more information, please contact our marketing team.</label>
            </div>
        </List>
    <iframe id="ifile" name="ifile" :src="iframeUrl" style="display:none"></iframe>
    </div>
</template>

<script>
import List from "../components/common/List.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
import { Topic,topicList,documentTypeList,DocumentType } from "@/components/Exhibitions/data.js";
import { unshiftAll } from "@/methods/selection.js";
export default {
    components:{
        List,
        Breadcrumb
    },
    data () {
        return {
            tanle:[{name:"Name",label:"File Name",type:"file",width:'500px'},{name:"DocumentTypeName",label:"Document Type",width:'200px'},{name:"PublishTime",label:"Last Updated"},{name:"Size",label:"Size"}],
            updateList:0,
            updateBlock:false,
            updateForm:{},
            headers:[{label:"Home",path:"/dashboard"},{label:"Exhibitions",path:"/exhibitions"}],
            iframeUrl:"",
            searchData:{
                Topic:"all",
                DocumentType:"all"
            },
            topicList:unshiftAll(topicList),
            documentTypeList:unshiftAll(documentTypeList),
            operat: [{
                text: "Download",
                eventName: "download2",
                type: "primary"
            }]
        };
    },
    created () {},
    methods:{
        dealListData (data) {
            for(let i in data) {
                data[i].TopicName = Topic[data[i].Topic];
                data[i].DocumentTypeName = DocumentType[data[i].DocumentType];
            }
            return data;
        },
        download2 (data) {
            this.download(data.Name);
        },
        download (data) {
            this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/marketingMaterials/${data}`;
        }
    },
    computed: {},
    watch:{}
};
</script>
